import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
export const Projects = () => {
  const projects = [{
    title: 'KDTable',
    description: '一个包含很多好玩特性的表格组件',
    image: 'https://panxiaoanblog.oss-cn-shenzhen.aliyuncs.com/img/image-20250816103838210.png',
    tags: ['React', 'rxjs', 'redux', 'table']
  }, {
    title: '好青年',
    description: '一个人可以走得更快，一群人可以走得更远',
    image: 'https://panxiaoanblog.oss-cn-shenzhen.aliyuncs.com/img/image-20250816104044488.png',
    tags: ['React', 'Taro', 'NestJS', 'TypeScript', 'PostgreSQL']
  }];
  return <section id="projects" className="py-16 bg-stone-100" data-id="element-143">
      <div className="container mx-auto px-4" data-id="element-144">
        <div className="text-center mb-12" data-id="element-145">
          <h2 className="text-3xl font-light text-stone-800 mb-2 inline-block border-b-2 border-red-700 pb-1" data-id="element-146">
            作品
          </h2>
          <p className="text-sm text-stone-500" data-id="element-147">参与做过</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-148">
          {projects.map((project, index) => <div key={index} className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300 group" data-id="element-149">
              <div className="aspect-video relative overflow-hidden" data-id="element-150">
                <img src={project.image} alt={project.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-151" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4" data-id="element-152">
                  <a href="#" className="text-white flex items-center" data-id="element-153">
                    View Project <ExternalLinkIcon size={16} className="ml-1" data-id="element-154" />
                  </a>
                </div>
              </div>
              <div className="p-6" data-id="element-155">
                <h3 className="text-xl text-stone-800 mb-2" data-id="element-156">{project.title}</h3>
                <p className="text-stone-600 mb-4" data-id="element-157">{project.description}</p>
                <div className="flex flex-wrap gap-2" data-id="element-158">
                  {project.tags.map((tag, idx) => <span key={idx} className="px-3 py-1 bg-indigo-900/10 text-indigo-900 text-sm rounded-full" data-id="element-159">
                      {tag}
                    </span>)}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};